/**
 * Shared learning content destinations (grammar, Redemittel).
 *
 * Used by the learning sidebar and the `/learning` hub so route targets stay in sync.
 *
 * @module learningNavigation
 */

import { BookOpen, MessageSquare, type LucideIcon } from 'lucide-react';
import { ROUTES } from '@/lib/routeConstants';

export interface LearningContentDestination {
  readonly id: 'grammar' | 'sentences';
  readonly path: string;
  readonly icon: LucideIcon;
}

export const LEARNING_CONTENT_DESTINATIONS: readonly LearningContentDestination[] = [
  { id: 'grammar', path: ROUTES.LEARNING_GRAMMAR, icon: BookOpen },
  { id: 'sentences', path: ROUTES.LEARNING_SENTENCES, icon: MessageSquare },
];
